export const numberWithCommas = (number: number) => {
  console.log(number);
  return number
    .toFixed(0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export const percentageString = (number: number) => {
  return number.toFixed(1).replace(/\.?0+$/, '') + '%';
};
